"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreBackedConfiguration = void 0;
const configuration_store_utils_1 = require("./configuration-store/configuration-store-utils");
const constants_1 = require("./constants");
class StoreBackedConfiguration {
    constructor(flagConfigurationStore, banditVariationConfigurationStore, banditModelConfigurationStore) {
        this.flagConfigurationStore = flagConfigurationStore;
        this.banditVariationConfigurationStore = banditVariationConfigurationStore;
        this.banditModelConfigurationStore = banditModelConfigurationStore;
    }
    async hydrateConfigurationStores(flagConfig, banditVariationConfig, banditModelConfig) {
        const didUpdateFlags = await (0, configuration_store_utils_1.hydrateConfigurationStore)(this.flagConfigurationStore, flagConfig);
        const promises = [];
        if (this.banditVariationConfigurationStore && banditVariationConfig) {
            promises.push((0, configuration_store_utils_1.hydrateConfigurationStore)(this.banditVariationConfigurationStore, banditVariationConfig));
        }
        if (this.banditModelConfigurationStore && banditModelConfig) {
            promises.push((0, configuration_store_utils_1.hydrateConfigurationStore)(this.banditModelConfigurationStore, banditModelConfig));
        }
        await Promise.all(promises);
        return didUpdateFlags;
    }
    getBandit(key) {
        return this.banditModelConfigurationStore?.get(key) ?? null;
    }
    getFlagVariationBandit(flagKey, variationValue) {
        const banditVariations = this.banditVariationConfigurationStore?.get(flagKey);
        const banditKey = banditVariations?.find((banditVariation) => banditVariation.variationValue === variationValue)?.key;
        if (banditKey) {
            // Retrieve the model parameters for the bandit
            return this.getBandit(banditKey);
        }
        return null;
    }
    getFlag(key) {
        return this.flagConfigurationStore.get(key) ?? null;
    }
    getFlagConfigDetails() {
        return {
            configFetchedAt: this.flagConfigurationStore.getConfigFetchedAt() ?? '',
            configPublishedAt: this.flagConfigurationStore.getConfigPublishedAt() ?? '',
            configEnvironment: this.flagConfigurationStore.getEnvironment() ?? {
                name: '',
            },
            configFormat: this.flagConfigurationStore.getFormat() ?? '',
        };
    }
    getFlagBanditVariations(flagKey) {
        return this.banditVariationConfigurationStore?.get(flagKey) ?? [];
    }
    getFlagKeys() {
        return this.flagConfigurationStore.getKeys();
    }
    getFlags() {
        return this.flagConfigurationStore.entries();
    }
    isObfuscated() {
        return constants_1.OBFUSCATED_FORMATS.includes(this.getFlagConfigDetails().configFormat ?? 'SERVER');
    }
    isInitialized() {
        return (this.flagConfigurationStore.isInitialized() &&
            (!this.banditVariationConfigurationStore ||
                this.banditVariationConfigurationStore.isInitialized()) &&
            (!this.banditModelConfigurationStore || this.banditModelConfigurationStore.isInitialized()));
    }
    getBandits() {
        return this.banditModelConfigurationStore?.entries() ?? {};
    }
    getBanditVariations() {
        return this.banditVariationConfigurationStore?.entries() ?? {};
    }
}
exports.StoreBackedConfiguration = StoreBackedConfiguration;
//# sourceMappingURL=i-configuration.js.map